// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__3PTwE","text":"SelectPayment_text__2YSBe","title":"SelectPayment_title__1Wjgc","btn":"SelectPayment_btn__3NSW0"};